import React from "react";
import "./ListOfDocuments.css";

const ListOfDocuments = () => {
  return (
    <>
      <div id="list-of-documents" className="bg-transparent">
        <div id="how-it-works-container">
          <div id="documents-content" className="bg-transparent">
            <div className="documents-content-container bg-transparent">
              <div className="content-box w-100 bg-transparent ">
                {" "}
                <div className="documents-text-box bg-transparent">
                  <div className="bg-transparent">
                    <div className="bg-transparent">
                      <h4 className="bg-transparent" id="documents-heading">
                        How it Works
                      </h4>
                    </div>
                    <div className="text-box bg-transparent">
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          Enter your loan details and basic information to check
                          eligibility.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          We compare top lenders to find you the lowest interest
                          rate and best terms.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          Transfer your loan with ease and start saving on your
                          EMIs right away.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="documents-image-box  d-md-block bg-transparent">
                  <div className="bg-transparent">
                    <img
                      className="documents-image bg-transparent"
                      src={Image}
                      alt="docuents-image"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListOfDocuments;
